"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GaslessOnboardingError = void 0;
const details_1 = require("./details");
class GaslessOnboardingError extends Error {
    constructor(name, customMessage) {
        super();
        this.name = name;
        this.message = customMessage
            ? `${details_1.ERROR_DETAILS[name]} | ${customMessage}`
            : `${details_1.ERROR_DETAILS[name]}`;
    }
}
exports.GaslessOnboardingError = GaslessOnboardingError;
